import css from '@emotion/css/macro'
import styled from '@emotion/styled/macro'
import { Flex } from '@rebass/grid/emotion'
import { ifProp } from 'mixins'
import { IButtonProps } from 'office-ui-fabric-react'
import * as React from 'react'
import { AppNavigation, AppNavigationProps } from '../AppNavigation'

// const collapseWidth = appNavigationCollapseWidth

// const drawerActionStyles = ({ theme }: { theme?: Theme }) => css`
//   height: ${commandBarHeight}px;
//   color: ${theme!.palette.themePrimary};
//   &:hover {
//     background-color: ${theme!.palette.themeLighter};
//   }
// `

// const ExpandablePane = styled(Flex)(
//   {
//     overflow: 'hidden',
//   },
//   (props: { isExpanded: boolean }) =>
//     props.isExpanded
//       ? {
//           minWidth: `${appNavigationWidth}px`,
//         }
//       : {
//           width: `${collapseWidth}px`,
//         }
// )
const CollapsablePane = styled(Flex)`
  overflow: hidden;

  /* transition: width 0.66s ease-in-out; */
  .ms-Nav-linkText {
    transition: opacity 0.33s;
    opacity: 1;
  }

  ${ifProp(
    { isCollapsed: true },
    css`
      .ms-Nav-linkText {
        opacity: 0;
      }
    `,
    css`
      .ms-Nav-linkText {
        transition-delay: 0.33s;
      }
    `
  )}
`

// const DrawerActions = styled(Flex)`
//   /* background: ${themeColor('neutralLighter')}; */
//   border-bottom: 1px solid ${themeColor('neutralLight')};
//   height: ${commandBarHeight}px;
//   overflow: hidden;
// `
// const DrawerToggleAction = styled(IconButton)`
//   ${drawerActionStyles};
//   width: ${collapseWidth}px;
// `
// const DrawerContextAction = styled(ActionButton)`
//   ${drawerActionStyles};
// `
const Root = styled(Flex)`
  height: 100%;
  & > div + * {
    overflow: hidden;
  }
`
export interface AppNavigationDrawerInterface {
  appNavigationProps?: AppNavigationProps
  appNavigation?: React.ReactNode
  contextActionProps?: IButtonProps
}

export const AppNavigationDrawer: React.FunctionComponent<
  AppNavigationDrawerInterface
> = ({ appNavigation, appNavigationProps, contextActionProps, children }) => {
  const [isCollapsed] = React.useState(false)

  // const toggleCollapsed = React.useMemo(
  //   () => () => setIsCollapsed(!isCollapsed),
  //   [isCollapsed]
  // )

  return (
    <Root flexDirection="row" width="100%">
      <CollapsablePane
        flexDirection="column"
        flex="0 0 auto"
        isCollapsed={isCollapsed}
      >
        {/* <DrawerActions alignItems="stretch">
          <DrawerToggleAction
            width={collapseWidth}
            iconProps={{
              iconName: 'GlobalNavButton',
            }}
            onClick={toggleCollapsed}
          />
          {isCollapsed && contextActionProps && (
            <DrawerContextAction {...contextActionProps} />
          )}
        </DrawerActions> */}
        {appNavigation ? (
          appNavigation
        ) : (
          <AppNavigation {...appNavigationProps!} />
        )}
      </CollapsablePane>
      {children}
    </Root>
  )
}

export default AppNavigationDrawer
